import styled from "styled-components";

const StyledLoginScreen = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  color: ${({ theme }) => theme.colors.text};
  padding: 10px 20px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  .retry-span {
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
    text-decoration: underline;
    font-weight: 600;
    cursor: pointer;
    display: block;
    text-align: center;
    margin-top: 10px;
  }
  .error-message {
    font-size: 12px;
    margin-top: 8px;
    color: #ef6469;
    width: 100%;
    text-align: center;
    font-weight: 600;
  }
  h2 {
    font-size: 20px;
    margin-top: 0;
  }
  div {
    label {
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
    input {
      min-width: 100%;
      width: 100%;
      height: 44px;
      border-radius: 8px;
      border: 0.5px solid rgba(0, 0, 0, 0.3);
      background: var(--new-bg, #f7f7fa);
      box-sizing: border-box;
      padding: 16px;
      margin: 6px 0 12px 0;
    }
    .container-phone {
      margin: 12px 0;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      border-radius: 8px;
      .country-name {
        color: #000;
      }
      .search-bar {
        width: 280px;
        .search-emoji.search-bar-emoji {
          display: none;
        }
        .search-box {
          font-size: 16px;
        }
      }
      .selected-flag {
        border-radius: 15px;
      }
      .flag-dropdown {
        border-radius: 15px;
        border: none;
        background: transparent;
        top: 6px;
        bottom: 6px;
        left: 6px;
      }
      .flag-dropdown.open .selected-flag {
        background: transparent !important;
      }
      .react-tel-input.selected-flag:hover {
        background: transparent !important;
      }
      input {
        min-width: 100%;
        width: 100%;
        height: 44px;
        border-radius: 8px;
        border: 0.5px solid rgba(0, 0, 0, 0.3);
        background: var(--new-bg, #f7f7fa);
        color: #000;
        box-sizing: border-box;
        padding: 16px;
        padding-left: 50px;
      }
    }
  }

  .logo {
    position: fixed;
    left: 30px;
    top: 30px;
    z-index: 9;
    width: 15%;
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      width: 5%;
    }
  }
`;

export default StyledLoginScreen;
